import { render, staticRenderFns } from "./PrepAreaCard.vue?vue&type=template&id=ec176740&"
import script from "./PrepAreaCard.vue?vue&type=script&lang=ts&"
export * from "./PrepAreaCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports